module.exports = __webpack_public_path__ + "d3dfc9bd0c611c80aed0afe054b85936.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/power_has_a_price-1024.webp
// module id = 502
// module chunks = 0